const isDocumentHidden = function() {
  // According to the web API, these are the possible hidden values
  // depending on the browser.
  // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API#Example
  return !!(document.hidden || document.webkitHidden || document.msHidden);
};

export default isDocumentHidden;
